import React, {useEffect, useRef, useState} from 'react';
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import IconRichTextView from "../../../components/input/IconRichTextView";
import {useHistory} from "react-router-dom";
import {callApi} from "../../../connection/ClientApi";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";
import Urls from "../../../connection/Urls";

import messages from "res/messages/farsi";
import {getButtonHeight, getTextViewHeight, IsF, IsLP_MP, IsM, IsSM, IsT} from "my-styles/media/media";

import ICSend from "res/images/telegram.png";
import ICComment from "res/images/comment.png";
import TitleAddHeader from "../address/TitleAddHeader";
import ICBackIcon from "res/images/back.png";

import attachMic from "res/images/mic.png";
import attachFile from "res/images/attach_file.png";
import ICError from "res/images/error.png";
import {basketViewModel} from "../../../viewModels/Basket.viewModel";
import {RECORD_STATUS, useAudioRecorder} from '@sarafhbk/react-audio-recorder'
import DialogMessage from "components/dialogMessage/DialogMessage";

import ICPaused from "res/images/motion_paused.svg";
import ICstop from "res/images/stop_circle.svg";
import StopCircleOutlinedIcon from "@mui/icons-material/StopCircleOutlined";
import MicNoneOutlinedIcon from "@mui/icons-material/MicNoneOutlined";
import ICDelete from "res/images/delete_red.png";
import {Helmet} from "react-helmet";

export default function AnswerTicket(props) {

    const history = useHistory()

    const urlParams = props.location;

    const imageSelector = useRef(null);
    const [description, setDescription] = useState();
    const [getConfig,setConfig]=useState({});
    const [selectedPhotos, setSelectedPhotos] = useState([]);
    const [selectedNamePhotos, setSelectedNamePhotos] = useState([]);
    const [audioURL, setAudioURL] = useState(null);
    const [getAudioResult,setAudioResult]=useState(null);
    const [dialogRemoveVoiceShowStatus,setDialogRemoveVoiceShowStatus]=useState(false);
    const [dialogRecordingVoice, setDialogRecordingVoice] = useState(false);
    const [dialogMaxTimeVoiceStatus, setDialogMaxTimeVoiceStatus] = useState(false);
    const [loading, setLoading] = useState(false);

    const {
        audioResult,
        timer,
        startRecording,
        stopRecording,
        pauseRecording,
        resumeRecording,
        status,
        errorMessage
    } = useAudioRecorder();

    useEffect(() => {
        requestGetTicketSubject()
    }, []);
    useEffect(() => {
        if(timer && timer>=getConfig.voiceLength*60){
            handleStopRecording();
            setDialogMaxTimeVoiceStatus(true);
        }
    }, [timer])

    useEffect(() => {
        if(errorMessage){
            if (errorMessage.indexOf("Permission") > -1) {
                props.onAlert('مرورگر دسترسی لازم برای ضبط صدا را ندارد');
            } else if (errorMessage.indexOf("device") > -1) {
                props.onAlert('میکروفون متصل نیست');
            }
        }
    }, [errorMessage])

    function getDialogRemoveVoiceMessage() {
        return <DialogMessage
            showStatus={dialogRemoveVoiceShowStatus}
            title='حذف پیام صوتی'
            message='آیا از حذف پیام صوتی ضبط شده اطمینان دارید؟'
            submitTitle={messages.submit}
            closeTitle={messages.no}
            onCloseClicked={() => {
                setDialogRemoveVoiceShowStatus(false);
            }}
            onSubmitClicked={() => {
                setDialogRemoveVoiceShowStatus(false);
                stopRecording();
                setAudioURL(null);
                setAudioResult(null);
            }}
        />
    }

    function getDialogMaxTimeVoice() {
        return <DialogMessage
            showStatus={dialogMaxTimeVoiceStatus}
            title='خطا'
            message='حداکثر طول پیام صوتی 3 دقیقه'
            submitTitle={messages.submit}
            onSubmitClicked={() => {
                setDialogMaxTimeVoiceStatus(false);
            }}
        />
    }

    const handleStopRecording = () => {
        stopRecording();
        setLoading(false);
        setAudioResult(new Blob([audioResult], { type: 'audio/wav' }))
        setAudioURL(URL.createObjectURL(new Blob([audioResult], { type: 'audio/wav' })));

    };

    const handleDeleteRecording =()=>{
        setDialogRemoveVoiceShowStatus(true);
    }

    const handleStartRecording = () => {
        setAudioResult(null);
        startRecording();
        setLoading(true);
    };

    function showDialogRecordingVoice() {
        return <DialogMessage
            showStatus={dialogRecordingVoice}
            title='خطای ثبت پاسخ جدید'
            message='شما یک پیام صوتی در حال ضبط دارید لطفا ابتدا آن را متوقف یا حذف نمایید'
            submitTitle={messages.submit}
            onSubmitClicked={() => {
                setDialogRecordingVoice(false);
            }}
        />
    }

    const handleFileChange = async  (e) => {
        const files = e.target.files;
        const newImages = [];
        const newNameImages = [];

        let selectedCountPhotos=selectedPhotos.length;

        let countSelectAndBeforSelect=files.length+selectedCountPhotos;

        if(countSelectAndBeforSelect>=getConfig.imageCount){
            props.onAlert(messages.maxCountSelectImage);
        }

        let countDefaultFiles=files.length>getConfig.imageCount?getConfig.imageCount:files.length;

        let sizeDefaultImage=getConfig.imageSize*1024*1024;

        for (let i = 0; i < countDefaultFiles; i++) {
            const file = files[i];
            const fileSizeInBytes = file.size;
            if(sizeDefaultImage<=fileSizeInBytes){
                props.onAlert('حداکثر سایز فایل انتخابی '+getConfig.imageSize+' مگابایت می باشد');
            }else{
                const url = URL.createObjectURL(file);
                const response = await uploadImageToServer(file);
                newImages.push(url);
                newNameImages.push(response.data);
                if (response) {
                    let selectedPhotosList=[...selectedPhotos, ...newImages];
                    let selectedNamePhotosList=[...selectedNamePhotos, ...newNameImages];

                    setSelectedPhotos(selectedPhotosList.slice(0, 5));
                    setSelectedNamePhotos(selectedNamePhotosList.slice(0, 5));
                }
            }
        }
    };

    const uploadImageToServer = async (image) => {
        try {
            const formData = new FormData();
            formData.append('image', image);
            return  await callApiAsync(Urls.uploadImage, formData);
        } catch (error) {
            props.onAlert(messages.sendMessageError);
            return null;
        }
    };

    const callApiAsync = (url, data) => {
        return new Promise((resolve, reject) => {
            callApi(
                url,
                data,
                (responseData) => {
                    resolve(responseData);
                },
                () => {
                    reject(new Error('خطا در درخواست API'));
                },
                () => {

                },
                () => {

                }
            );
        });
    };


    const handleDelete = async (imageName, index) => {
        try {
            const formData = new FormData();
            formData.append('images', imageName);


            const updatedPhotos = [...selectedPhotos];
            const updateSelectedNamePhotos  = [...selectedNamePhotos];
            updatedPhotos.splice(index, 1);
            updateSelectedNamePhotos.splice(index, 1);

            // حذف تصویر از سرور
            await deleteImageAsync(formData);


            setSelectedPhotos(updatedPhotos);
            setSelectedNamePhotos(updateSelectedNamePhotos);
        } catch (error) {
            props.onAlert(messages.sendMessageError);
        }
    };

    const deleteImageAsync = (formData) => {
        return new Promise((resolve, reject) => {
            callApi(
                Urls.deleteImage,
                formData,
                (responseData) => {
                    resolve(responseData);
                },
                () => {
                    reject(new Error('خطا در حذف تصویر'));
                },
                () => {

                },
                () => {

                }
            );
        });
    };

    const isValid = () => {

      if(!description ){
            props.onAlert(messages.errorDescription)
            return false;
        }
        return true;
    };


    async function requestSendMessage() {

        if(isValid()){
            let params = new FormData()

            if(status === RECORD_STATUS.RECORDING ){
                handleStopRecording();
                setDialogRecordingVoice(true);
                return false;
            }else if(status === RECORD_STATUS.PAUSED){
                handleStopRecording();
                setDialogRecordingVoice(true);
                return false;
            }else if(audioURL){
                const audioResultBlob = await fetch(audioResult).then((r) => r.blob())
                params.append("voice", audioResultBlob,'audio.wav');
            }

            params.append("ticket_id", props.location.state.ticket_id);
            params.append("message", description);
            params.append(`images`, selectedNamePhotos.join(','));

            callApi(Urls.addTicketComment, params, (response) => {
                    props.onAlert(messages.sendMessageSuccess, ALERT_TYPES.SUCCESS);
                     props.onNavigate(history, '/ticketDetail', {
                     ticket_id: props.location.state.ticket_id,
                      })
                }, () => {
                    props.onAlert(messages.sendMessageError)
                }, () => {

                }, () => {

                }
            )
        }

    }




    const requestGetTicketSubject=()=>{
        basketViewModel.getTicketSubject((data) => {
            if (data) {
                setConfig(data.config);
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {

        }, () => {

        })
    }

    return (
        <>
            <Helmet>
                <title>صرفه مارکت - پاسخ تیکت</title>
                <meta property="og:image" content="%PUBLIC_URL%/favicon.ico"/>
                <meta property="og:url" content="https://sarfemarket.ir/"/>
                <meta name="google-site-verification" content="a7UDcP_j_QBlp1S7KGeczLTlvDmYkzvwyBo7Qa-qbH0"/>
            </Helmet>
            <div>
                <div className="marginTopBottomSmall">
                    <TitleAddHeader
                        icon={ICBackIcon}
                        title="پاسخ به درخواست پشتیبانی"
                        onIconClick={props.handleClose}
                       />
                </div>
            </div>
            {IsSM() || IsM() ?
               <div className="backgroundImageAnswerTicketStyle" >
                   <div className="marginSmall">
                       <table className="fullWidth center" style={{height: "35em"}}>
                           <tbody>
                           <tr>
                               <td style={{position:'relative'}}>
                                   <center className="responsiveCenterTagTicket responsiveCenterTagTicket1" >
                                       <div style={{width: "100%",top:'10px'}} >
                                           <IconRichTextView
                                               className="boxInputMassageTicket boxInputMassageTicket"
                                               placeholder={messages.messageDescription}
                                               icon={<img alt={"صرفه مارکت"} src={ICComment}
                                                          className="marginSmall xSmallIcon"/>}
                                               onChange={(e) => {
                                                   setDescription(e.target.value)
                                               }}/>
                                       </div>

                                       {/*start record voice */}
                                       <div style={{width: "100%"}} className="cardImageSelect1 boxInputMassageTicket">
                                           <div className="boxRecordingVoice boxRecordingVoice2">

                                                   {
                                                       (<span className="spanVoicercord">
                                                                {status === RECORD_STATUS.RECORDING ?(
                                                                    <span style={{display:'flex',alignItems:'center',gap:'0.3rem'}}  onClick={handleStopRecording}>

                                                                          <StopCircleOutlinedIcon className="redColor" fontSize={"small"}/>
                                                                      <p className="recordingStyle" style={{display:'flex'}}>در حال ضبط پیام صوتی
                                                                          <div className="loading-dots">
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                          </div></p>
                                                                  </span>

                                                                ) :
                                                                        <span style={{display:'flex',alignItems:'center'}}  onClick={handleStartRecording}>
                                                                     <MicNoneOutlinedIcon className="" fontSize={"small"}/>

                                                                            {(status==='idle' && audioResult =='' && <span className=""> {messages.addVoice}</span> )}
                                                                </span>

                                                                }

                                                              </span>
                                                       )
                                                   }

                                                   <span style={{display:'flex',gap:'0.3rem'}}>
                                                     <p className="recordingStyle">
                                                            {status === RECORD_STATUS.RECORDING ? new Date(timer * 1000).toISOString().substr(14, 5): ''}
                                                       </p>
                                                </span>
                                                   { audioURL && status==='idle' && audioResult !=='' ? (<div style={{display:'flex'}}>
                                                    <span className="spanRemoveVoice"  onClick={handleDeleteRecording} >
                                                     <img className="" src={ICDelete} alt={"صرفه مارکت"} style={{width:'1rem',height:'1rem'}} />
                                                    </span>
                                                       <audio controls src={audioResult} className="styleAdiorecord" style={{height:'1.2rem',width:'11rem'}} />
                                                   </div>):''}

                                           </div>
                                           <span className="textLight textLight1">حداکثر طول پیام صوتی {getConfig.voiceLength} دقیقه</span>
                                       </div>

                                       {/*end record voice */}
                                       <div  className="cardImageSelect1 boxInputMassageTicket"  style={{marginTop:'1.5rem',width: "100%"}}>
                                   <span style={{display:'flex',alignItems:'center',fontSize:'0.9rem'}} onClick={() => {
                                       imageSelector.current.click()
                                   }}>
                                                   <img alt={"صرفه مارکت"} src={attachFile}
                                                        className="marginSmall xSmallIcon"/>
                                       {messages.addIamge}
                                            </span>

                                           <div className="threeFromFive multiCardShowImage bodyCardImageSelect" >
                                               {selectedPhotos.map((photo, index) => (
                                                   <div style={{position:'relative',width:'5rem',height:'3rem',margin:'1rem 0'}}  key={index}>
                                                       <img className="leftSideBg clearImageIcon" src={ICError} alt={"صرفه مارکت"} onClick={() => handleDelete(selectedNamePhotos[index],index)}/>
                                                       <img className="leftSideBg itemImage" src={photo} alt={"صرفه مارکت"}/>
                                                   </div>
                                               ))}

                                           </div>
                                           <span className="textLight textLight1">{selectedPhotos.length}/{getConfig.imageCount} | حداکثر حجم هر تصویر {getConfig.imageSize} مگابایت</span>
                                       </div>
                                       <div style={{width: "100%",marginTop:'1.5rem'}}>
                                           <IconTitleButtonRound
                                               backgroundcolor="var(--blue_3)"
                                               height={getButtonHeight()}
                                               fontSize="mediumTextBold"
                                               onClick={() => {
                                                   requestSendMessage()
                                               }}
                                               icon={<img alt={"صرفه مارکت"} src={ICSend}
                                                          className="marginSmall xSmallIcon"/>}
                                               title={messages.sendMessage}/>
                                       </div>
                                   </center>
                               </td>
                           </tr>
                           </tbody>
                       </table>
                   </div>
               </div> :
                IsF() ?
                  <div className="backgroundImageAnswerTicketStyle" >
                      <div className="marginSmall"  >
                          <table className="fullWidth center" style={{height: "35em"}}>
                              <tbody>
                              <tr>
                                  <td style={{position:'relative'}}>
                                      <center className="responsiveCenterTagTicket responsiveCenterTagTicket1">
                                          <div style={{width: "100%"}}>
                                              <IconRichTextView
                                                  className="boxInputMassageTicket boxInputMassageTicket"
                                                  placeholder={messages.messageDescription}
                                                  icon={<img alt={"صرفه مارکت"} src={ICComment}
                                                             className="marginSmall xSmallIcon"/>}
                                                  onChange={(e) => {
                                                      setDescription(e.target.value)
                                                  }}/>
                                          </div>

                                          {/*start record voice */}
                                          <div style={{width: "100%"}} className="cardImageSelect1 boxInputMassageTicket">
                                              <div className="boxRecordingVoice boxRecordingVoice2">
                                                      {
                                                          (<span className="spanVoicercord">
                                                                {status === RECORD_STATUS.RECORDING ?(
                                                                    <span style={{display:'flex',alignItems:'center',gap:'0.3rem'}}  onClick={handleStopRecording}>

                                                                          <StopCircleOutlinedIcon className="redColor" fontSize={"small"}/>
                                                                      <p className="recordingStyle" style={{display:'flex'}}>در حال ضبط پیام صوتی
                                                                          <div className="loading-dots">
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                          </div></p>
                                                                  </span>

                                                                ) :(<span style={{display:'flex',alignItems:'center'}}  onClick={handleStartRecording}>
                                                                     <MicNoneOutlinedIcon className="" fontSize={"small"}/>

                                                                     <span className=""> {messages.addVoice}</span>
                                                                </span>)}

                                                              </span>
                                                          )
                                                      }

                                                      <span style={{display:'flex',gap:'0.3rem'}}>
                                                     <p className="recordingStyle">
                                                            {status === RECORD_STATUS.RECORDING ? new Date(timer * 1000).toISOString().substr(14, 5): ''}
                                                       </p>
                                                </span>
                                                      { audioURL && status==='idle' && audioResult !=='' ? (<div style={{display:'flex'}}>
                                                    <span className="spanRemoveVoice"  onClick={handleDeleteRecording} >
                                                     <img className="" src={ICDelete} alt={"صرفه مارکت"} style={{width:'1rem',height:'1rem'}} />
                                                    </span>
                                                          <audio controls src={audioResult} className="styleAdiorecord" style={{height:'1.2rem',width:'11rem'}} />
                                                      </div>):''}



                                              </div>
                                              <span className="textLight textLight1">حداکثر طول پیام صوتی {getConfig.voiceLength} دقیقه</span>
                                          </div>

                                          {/*end record voice */}
                                          <div  className="cardImageSelect1 boxInputMassageTicket"  style={{marginTop:'2rem',width: "100%"}}>
                                   <span style={{display:'flex',alignItems:'center',fontSize:'0.9rem'}} onClick={() => {
                                       imageSelector.current.click()
                                   }}>
                                                   <img alt={"صرفه مارکت"} src={attachFile}
                                                        className="marginSmall xSmallIcon"/>
                                       {messages.addIamge}
                                            </span>

                                              <div className="threeFromFive multiCardShowImage bodyCardImageSelect" >
                                                  {selectedPhotos.map((photo, index) => (
                                                      <div style={{position:'relative',width:'5rem',height:'3rem',margin:'1rem 0'}}  key={index}>
                                                          <img className="leftSideBg clearImageIcon" src={ICError} alt={"صرفه مارکت"} onClick={() => handleDelete(selectedNamePhotos[index],index)}/>
                                                          <img className="leftSideBg itemImage" src={photo} alt={"صرفه مارکت"}/>
                                                      </div>
                                                  ))}

                                              </div>
                                              <span className="textLight textLight1">{selectedPhotos.length}/{getConfig.imageCount} | حداکثر حجم هر تصویر {getConfig.imageSize} مگابایت</span>
                                          </div>
                                          <div style={{width: "100%", marginTop: "2rem"}}>
                                              <IconTitleButtonRound
                                                  backgroundcolor="var(--blue_3)"
                                                  height={getButtonHeight()}
                                                  fontSize="mediumTextBold"
                                                  onClick={() => {
                                                      requestSendMessage()
                                                  }}
                                                  icon={<img alt={"صرفه مارکت"} src={ICSend}
                                                             className="marginSmall xSmallIcon"/>}
                                                  title={messages.sendMessage}/>
                                          </div>
                                      </center>
                                  </td>
                              </tr>
                              </tbody>
                          </table>
                      </div>
                  </div>:
                    IsT() ?
                     <div className="backgroundImageAnswerTicketStyle" >
                         <div className="marginSmall">
                             <table className="fullWidth center" style={{height: "35em"}}>
                                 <tbody>
                                 <tr>
                                     <td style={{position:'relative'}}>
                                         <center className="responsiveCenterTagTicket responsiveCenterTagTicket1">
                                             <div style={{width: "100%"}}>
                                                 <IconRichTextView
                                                     className="boxInputMassageTicket boxInputMassageTicket"
                                                     placeholder={messages.messageDescription}
                                                     icon={<img alt="صرفه مارکت"  src={ICComment}
                                                                className="marginSmall xSmallIcon"/>}
                                                     onChange={(e) => {
                                                         setDescription(e.target.value)
                                                     }}/>
                                             </div>

                                             {/*start record voice */}
                                             <div style={{width: "100%"}} className="cardImageSelect1 boxInputMassageTicket">
                                                 <div className="boxRecordingVoice boxRecordingVoice2">

                                                         {
                                                             (<span className="spanVoicercord">
                                                                {status === RECORD_STATUS.RECORDING ?(
                                                                    <span style={{display:'flex',alignItems:'center',gap:'0.3rem'}}  onClick={handleStopRecording}>

                                                                          <StopCircleOutlinedIcon className="redColor" fontSize={"small"}/>
                                                                      <p className="recordingStyle" style={{display:'flex'}}>در حال ضبط پیام صوتی
                                                                          <div className="loading-dots">
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                          </div></p>
                                                                  </span>

                                                                ) :(<span style={{display:'flex',alignItems:'center'}}  onClick={handleStartRecording}>
                                                                     <MicNoneOutlinedIcon className="" fontSize={"small"}/>

                                                                     <span className=""> {messages.addVoice}</span>
                                                                </span>)}

                                                              </span>
                                                             )
                                                         }

                                                         <span style={{display:'flex',gap:'0.3rem'}}>
                                                     <p className="recordingStyle">
                                                            {status === RECORD_STATUS.RECORDING ? new Date(timer * 1000).toISOString().substr(14, 5): ''}
                                                       </p>
                                                </span>
                                                         { audioURL && status==='idle' && audioResult !=='' ? (<div style={{display:'flex'}}>
                                                    <span className="spanRemoveVoice"  onClick={handleDeleteRecording} >
                                                     <img className="" src={ICDelete} alt="صرفه مارکت" style={{width:'1rem',height:'1rem'}} />
                                                    </span>
                                                             <audio controls src={audioResult} className="styleAdiorecord" style={{height:'1.2rem',width:'11rem'}} />
                                                         </div>):''}


                                                 </div>
                                                 <span className="textLight textLight1">حداکثر طول پیام صوتی {getConfig.voiceLength} دقیقه</span>
                                             </div>

                                             {/*end record voice */}
                                             <div  className="cardImageSelect1 boxInputMassageTicket"  style={{marginTop:'2rem',width: "100%"}}>
                                   <span style={{display:'flex',alignItems:'center',fontSize:'0.9rem'}} onClick={() => {
                                       imageSelector.current.click()
                                   }}>
                                                   <img alt="صرفه مارکت"  src={attachFile}
                                                        className="marginSmall xSmallIcon"/>
                                       {messages.addIamge}
                                            </span>

                                                 <div className="threeFromFive multiCardShowImage bodyCardImageSelect" >
                                                     {selectedPhotos.map((photo, index) => (
                                                         <div style={{position:'relative',width:'5rem',height:'3rem',margin:'1rem 0'}}  key={index}>
                                                             <img className="leftSideBg clearImageIcon" src={ICError} alt="صرفه مارکت"  onClick={() => handleDelete(selectedNamePhotos[index],index)}/>
                                                             <img className="leftSideBg itemImage" src={photo} alt="صرفه مارکت" />
                                                         </div>
                                                     ))}

                                                 </div>
                                                 <span className="textLight textLight1">{selectedPhotos.length}/{getConfig.imageCount} | حداکثر حجم هر تصویر {getConfig.imageSize} مگابایت</span>
                                             </div>

                                             <div style={{width: "100%", marginTop: "2rem"}}>
                                                 <IconTitleButtonRound
                                                     backgroundcolor="var(--blue_3)"
                                                     height={getButtonHeight()}
                                                     fontSize="mediumTextBold"
                                                     onClick={() => {
                                                         requestSendMessage()
                                                     }}
                                                     icon={<img alt="صرفه مارکت"  src={ICSend}
                                                                className="marginSmall xSmallIcon"/>}
                                                     title={messages.sendMessage}/>
                                             </div>
                                         </center>
                                     </td>
                                 </tr>
                                 </tbody>
                             </table>
                         </div>
                     </div>:
                      <div className="backgroundImageAnswerTicketStyle" >

                          <div className="horizontalFullScreen" >
                              <div className=" marginTopBottomMedium" style={{width:'87%'}}>
                                  <table className="background full">
                                      <tbody>
                                      <tr>
                                          <td>
                                              <center className="responsiveCenterTagTicket">
                                                  <div style={{width: "87%"}}>
                                                      <IconRichTextView
                                                          className="boxInputMassageTicket boxInputMassageTicket"
                                                          placeholder={messages.messageDescription}
                                                          icon={<img alt="صرفه مارکت"  src={ICComment}
                                                                     className="marginSmall xSmallIcon"/>}
                                                          onChange={(e) => {
                                                              setDescription(e.target.value)
                                                          }}/>
                                                  </div>

                                                  {/*start record voice */}
                                                  <div style={{width: "87%"}} className="cardImageSelect1 boxInputMassageTicket">
                                                      <div className="boxRecordingVoice boxRecordingVoice2">

                                                              {
                                                                  (<span className="spanVoicercord">
                                                                {status === RECORD_STATUS.RECORDING ?(
                                                                    <span style={{display:'flex',alignItems:'center',gap:'0.3rem'}}  onClick={handleStopRecording}>

                                                                          <StopCircleOutlinedIcon className="redColor" fontSize={"small"}/>
                                                                      <p className="recordingStyle" style={{display:'flex'}}>در حال ضبط پیام صوتی
                                                                          <div className="loading-dots">
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                          </div></p>
                                                                  </span>

                                                                ) :(<span style={{display:'flex',alignItems:'center'}}  onClick={handleStartRecording}>
                                                                     <MicNoneOutlinedIcon className="" fontSize={"small"}/>

                                                                     <span className=""> {messages.addVoice}</span>
                                                                </span>)}

                                                              </span>
                                                                  )
                                                              }

                                                              <span style={{display:'flex',gap:'0.3rem'}}>
                                                     <p className="recordingStyle">
                                                            {status === RECORD_STATUS.RECORDING ? new Date(timer * 1000).toISOString().substr(14, 5): ''}
                                                       </p>
                                                </span>
                                                              { audioURL && status==='idle' && audioResult !=='' ? (<div style={{display:'flex'}}>
                                                    <span className="spanRemoveVoice"  onClick={handleDeleteRecording} >
                                                     <img className="" src={ICDelete} alt="صرفه مارکت"  style={{width:'1rem',height:'1rem'}} />
                                                    </span>
                                                                  <audio controls src={audioResult} className="styleAdiorecord" style={{height:'1.2rem',width:'11rem'}} />
                                                              </div>):''}



                                                      </div>
                                                      <span className="textLight textLight1">حداکثر طول پیام صوتی {getConfig.voiceLength} دقیقه</span>
                                                  </div>

                                                  {/*end record voice */}

                                                  <div  className="cardImageSelect1 boxInputMassageTicket"  style={{marginTop:'2rem',width: "87%"}}>
                                           <span style={{display:'flex',alignItems:'center',fontSize:'0.9rem'}} onClick={() => {
                                             imageSelector.current.click()
                                          }}>
                                                   <img alt="صرفه مارکت"  src={attachFile}
                                                        className="marginSmall xSmallIcon"/>
                                       {messages.addIamge}
                                            </span>

                                                      <div className="threeFromFive multiCardShowImage bodyCardImageSelect">
                                                          {selectedPhotos.map((photo, index) => (
                                                              <div style={{position:'relative',width:'5rem',height:'3rem',margin:'1rem 0'}}  key={index}>
                                                                  <img className="leftSideBg clearImageIcon" src={ICError} alt="صرفه مارکت"  onClick={() => handleDelete(selectedNamePhotos[index],index)}/>
                                                                  <img className="leftSideBg itemImage" src={photo} alt="صرفه مارکت" />
                                                              </div>
                                                          ))}

                                                      </div>
                                                      <span className="textLight textLight1">{selectedPhotos.length}/{getConfig.imageCount} | حداکثر حجم هر تصویر {getConfig.imageSize} مگابایت</span>
                                                  </div>


                                                  <div className="cardImageSelect1"  style={{marginTop:'2rem',width: "87%"}}>
                                                      <IconTitleButtonRound
                                                          backgroundcolor="var(--blue_3)"
                                                          height={getButtonHeight()}
                                                          fontSize="mediumTextBold"
                                                          onClick={() => {
                                                              requestSendMessage()
                                                          }}
                                                          icon={<img alt="صرفه مارکت"  src={ICSend}
                                                                     className="marginSmall xSmallIcon"/>}
                                                          title={messages.sendMessage}/>
                                                  </div>
                                              </center>
                                          </td>
                                      </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                      </div>}
            <input
                id='file'
                type='file'
                multiple
                onChange={handleFileChange}
                ref={imageSelector}
                style={{display: 'none'}}/>
            <div style={{opacity: 1}}
                 className="card shadow fullWidth fullHeight">
                {getDialogRemoveVoiceMessage()}
                {showDialogRecordingVoice()}
                {getDialogMaxTimeVoice()}
            </div>
        </>

    )

}